/**
 * LEP Slider — Hero packshot carousel with slide animation
 *
 * 50 packshotów (5 wariantów × 10 cykli), 5 backgroundów.
 * Perspective: 5 visible slots, decreasing size.
 * Slide animation: items shift left/right with CSS transitions.
 * Autoplay, swipe, prev/next arrows.
 */

(function () {
  'use strict';

  var SELECTOR = '[data-lep-slider]';
  var TOTAL_PACKS = 5;
  var TOTAL_SLIDES = 50;
  var VISIBLE_SLOTS = 5;
  var AUTOPLAY_INTERVAL = 3000;
  var SWIPE_THRESHOLD = 50;
  var TRANSITION_DURATION = 500; // ms — match CSS transition

  function init() {
    var sliders = document.querySelectorAll(SELECTOR);
    if (!sliders.length) return;
    sliders.forEach(function (slider) { setupSlider(slider); });
  }

  function setupSlider(slider) {
    var track = slider.querySelector('.lep-slider__track');
    var bgImages = slider.querySelectorAll('.lep-slider__bg img');
    var prevBtn = slider.querySelector('.lep-slider__arrow--prev');
    var nextBtn = slider.querySelector('.lep-slider__arrow--next');
    var decors = slider.querySelectorAll('.lep-slider__decor');

    var currentIndex = 0;
    var isAnimating = false;
    var autoplayTimer = null;
    var touchStartX = 0;
    var touchStartY = 0;

    // Build initial slots
    for (var i = 0; i < VISIBLE_SLOTS; i++) {
      var item = createItem((currentIndex + i) % TOTAL_PACKS, i);
      track.appendChild(item);
    }
    updateBg(bgImages, currentIndex);

    // --- Navigation ---
    if (prevBtn) prevBtn.addEventListener('click', function () { slide('prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { slide('next'); });

    // --- Swipe ---
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      pauseAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
        slide(dx < 0 ? 'next' : 'prev');
      }
      startAutoplay();
    }, { passive: true });

    // --- Autoplay ---
    slider.addEventListener('mouseenter', pauseAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(function () { slide('next'); }, AUTOPLAY_INTERVAL);
    }

    function stopAutoplay() {
      if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
    }

    function pauseAutoplay() { stopAutoplay(); }

    // --- Slide animation ---
    function slide(direction) {
      if (isAnimating) return;
      isAnimating = true;

      var items = track.querySelectorAll('.lep-slider__item');

      if (direction === 'next') {
        currentIndex = (currentIndex + 1) % TOTAL_SLIDES;

        // Create incoming item at slot 5 (offscreen right)
        var newPackIndex = (currentIndex + VISIBLE_SLOTS - 1) % TOTAL_PACKS;
        var incoming = createItem(newPackIndex, VISIBLE_SLOTS);
        track.appendChild(incoming);

        // Force reflow so the browser registers the initial position
        incoming.offsetHeight; // eslint-disable-line

        // Shift all items: slot N → slot N-1
        requestAnimationFrame(function () {
          // Outgoing (slot 0 → slot -1)
          items[0].setAttribute('data-slot', '-1');

          // Shift existing
          for (var i = 1; i < items.length; i++) {
            var currentSlot = parseInt(items[i].getAttribute('data-slot'), 10);
            items[i].setAttribute('data-slot', currentSlot - 1);
          }

          // Incoming: slot 5 → slot 4
          incoming.setAttribute('data-slot', VISIBLE_SLOTS - 1);
        });

        // After transition: remove outgoing
        setTimeout(function () {
          if (items[0] && items[0].parentNode) {
            items[0].parentNode.removeChild(items[0]);
          }
          isAnimating = false;
        }, TRANSITION_DURATION + 50);

      } else {
        // prev
        currentIndex = (currentIndex - 1 + TOTAL_SLIDES) % TOTAL_SLIDES;

        // Create incoming item at slot -1 (offscreen left)
        var newPackIdx = currentIndex % TOTAL_PACKS;
        var incomingPrev = createItem(newPackIdx, -1);
        track.insertBefore(incomingPrev, track.firstChild);

        // Force reflow
        incomingPrev.offsetHeight; // eslint-disable-line

        // Shift all items: slot N → slot N+1
        requestAnimationFrame(function () {
          var allItems = track.querySelectorAll('.lep-slider__item');

          // Outgoing (last item → slot 5)
          allItems[allItems.length - 1].setAttribute('data-slot', VISIBLE_SLOTS);

          // Shift existing (skip first — it's the incoming)
          for (var i = allItems.length - 2; i >= 1; i--) {
            var cs = parseInt(allItems[i].getAttribute('data-slot'), 10);
            allItems[i].setAttribute('data-slot', cs + 1);
          }

          // Incoming: slot -1 → slot 0
          incomingPrev.setAttribute('data-slot', '0');
        });

        // After transition: remove outgoing (last item)
        setTimeout(function () {
          var all = track.querySelectorAll('.lep-slider__item');
          var last = all[all.length - 1];
          if (last && last.parentNode) {
            last.parentNode.removeChild(last);
          }
          isAnimating = false;
        }, TRANSITION_DURATION + 50);
      }

      updateBg(bgImages, currentIndex);
      animateDecors(decors);
    }

    startAutoplay();
  }

  function animateDecors(decors) {
    decors.forEach(function (decor) {
      decor.classList.remove('is-animating');
      // Force reflow to restart animation
      decor.offsetHeight; // eslint-disable-line
      decor.classList.add('is-animating');

      decor.addEventListener('animationend', function handler() {
        decor.classList.remove('is-animating');
        decor.removeEventListener('animationend', handler);
      });
    });
  }

  function createItem(packIndex, slot) {
    var item = document.createElement('div');
    item.className = 'lep-slider__item';
    item.setAttribute('data-slot', slot);

    var img = document.createElement('img');
    img.src = 'assets/images/lep/slider/lep-pack-' + (packIndex + 1) + '.png';
    img.alt = 'Camel Blue KS — wariant ' + (packIndex + 1);
    img.draggable = false;
    item.appendChild(img);

    return item;
  }

  function updateBg(bgImages, currentIndex) {
    var bgIndex = currentIndex % TOTAL_PACKS;
    bgImages.forEach(function (bg, i) {
      bg.classList.toggle('is-active', i === bgIndex);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
